import React, { useState } from 'react'
import { PasswordHideIcon, PasswordLockSvg, PasswordShowIcon } from '../assets/svg/SvgComponent';
import { useBranding } from '../context/BrandingContext';
import axios from 'axios';
import { API_URL, getHeaders } from '../helper/commonApi';
import { useNavigate } from 'react-router-dom';

const ResetPasswordComponent = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [password, setPassword] = useState("");
    const [confirmPass, setConfirmPass] = useState("");
    const [showPass, setShowPass] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [passwordError, setPasswordError] = useState("");
    const [confirmError, setConfirmError] = useState("");
    const [error, setError] = useState("");

    const { colors, portalID } = useBranding();

    const userId = localStorage.getItem("_reset_user_id");
    const otp = localStorage.getItem("_reset_otp");

    const validateConfirmPassword = (value, passwordValue) => {
        if (!value) return "Confirm your password";
        if (value !== passwordValue) return "Passwords do not match";
        return "";
    };

    const validateForm = () => {
        const passErr = validatePassword(password);
        const confirmErr = validateConfirmPassword(confirmPass, password);

        setPasswordError(passErr);
        setConfirmError(confirmErr);

        if (passErr || confirmErr) return false;

        return true;
    };

    const validatePassword = (value) => {
        if (!value) return "New Password is required";

        const minLength = /.{8,}/;
        const hasUpper = /[A-Z]/;
        const hasLower = /[a-z]/;
        const hasNumber = /\d/;
        const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/;

        if (!minLength.test(value)) return "Must be at least 8 characters";
        if (!hasUpper.test(value)) return "Must include at least one uppercase letter";
        if (!hasLower.test(value)) return "Must include at least one lowercase letter";
        if (!hasNumber.test(value)) return "Must include at least one number";
        if (!hasSpecial.test(value)) return "Must include at least one special character";

        return "";
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;

        setLoading(true);

        try {
            const res = await axios.post(`${API_URL}/reset-password`, {
                portal_id: portalID,
                user_id: Number(userId),
                otp: otp,
                new_password: password,
            }, {
                headers: getHeaders()
            });

            if (res.status === 200 && res?.data?.status) {
                localStorage.removeItem('_register_GRE_forgot_password')
                localStorage.removeItem('_register_GRE_userEmail')
                localStorage.removeItem('_register_GRE_userId')
                localStorage.removeItem('_reset_otp')
                localStorage.removeItem('_reset_user_id')

                localStorage.setItem('_register_GRE_LOGIN_userId', userId)
                navigate("/");
            } else {
                setError(res?.data?.message || "Invalid OTP.");
            }
        } catch (err) {
            setError("Something went wrong.");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            <div style={{ margin: "10px" }}>
                <div className="container">
                    <div className="verify-otp-section">
                        <h2 class="text-3xl font-semibold text-black mb-2">Reset Password</h2>
                        <p class="text-gray-600 mb-6">Set your new password below.</p>

                        <div className="form">
                            {/* Password */}
                            <div className="input-wrapper">
                                <div className={`input-group ${passwordError ? "error" : ""}`}>
                                    <PasswordLockSvg />
                                    <input
                                        id="newPassword"
                                        name="newPassword"
                                        type={showPass ? "text" : "password"}
                                        placeholder="New Password"
                                        value={password}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setPassword(val);
                                            setPasswordError(validatePassword(val));
                                            setConfirmError(validateConfirmPassword(confirmPass, val));
                                        }}
                                        autoComplete="off"
                                    />
                                    <div
                                        className="input-type-password-toggle"
                                        onClick={() => setShowPass(!showPass)}
                                    >
                                        {showPass ? <PasswordShowIcon /> : <PasswordHideIcon />}
                                    </div>
                                </div>
                                {passwordError && (
                                    <span className="error-text">{passwordError}</span>
                                )}
                            </div>

                            {/* Confirm Password */}
                            <div className="input-wrapper">
                                <div className={`input-group ${confirmError ? "error" : ""}`}>
                                    <PasswordLockSvg />
                                    <input
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        type={showConfirm ? "text" : "password"}
                                        placeholder="Confirm Password"
                                        value={confirmPass}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setConfirmPass(val);
                                            setConfirmError(validateConfirmPassword(val, password));
                                        }}
                                        autoComplete="off"
                                    />
                                    <div
                                        className="input-type-password-toggle"
                                        onClick={() => setShowConfirm(!showConfirm)}
                                    >
                                        {showConfirm ? <PasswordShowIcon /> : <PasswordHideIcon />}
                                    </div>
                                </div>
                                {confirmError && (
                                    <span className="error-text">{confirmError}</span>
                                )}
                            </div>

                            {error && <p className="verify-otp-error">{error}</p>}

                            <button onClick={handleSubmit} className="register-btn btn black" style={{ backgroundColor: colors?.buttonBg }}>Reset Password</button>

                            {/* Submit */}
                            {/* <div onClick={loading ? null : handleSubmit} className="register-btn btn black" style={{ backgroundColor: colors?.buttonBg }}>
                                {loading ? (
                                    <span className="create-account-loader-btn" />
                                ) : (
                                    "Reset Password"
                                )}
                            </div> */}



                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResetPasswordComponent